export var AfriexRegionCode;
(function (AfriexRegionCode) {
    // Americas
    AfriexRegionCode["NorthAmerica"] = "NORTH_AMERICA";
    AfriexRegionCode["SouthAmerica"] = "SOUTH_AMERICA";
    AfriexRegionCode["Caribbean"] = "CARIBBEAN";
    // Europe
    AfriexRegionCode["NorthernEurope"] = "NORTHERN_EUROPE";
    AfriexRegionCode["WesternEurope"] = "WESTERN_EUROPE";
    AfriexRegionCode["CentralEurope"] = "CENTRAL_EUROPE";
    AfriexRegionCode["SouthernEurope"] = "SOUTHERN_EUROPE";
    AfriexRegionCode["EasternEurope"] = "EASTERN_EUROPE";
    // Africa
    AfriexRegionCode["NorthAfrica"] = "NORTH_AFRICA";
    AfriexRegionCode["WestAfrica"] = "WEST_AFRICA";
    AfriexRegionCode["CentralAfrica"] = "CENTRAL_AFRICA";
    AfriexRegionCode["EastAfrica"] = "EAST_AFRICA";
    AfriexRegionCode["SouthernAfrica"] = "SOUTHERN_AFRICA";
    // Asia
    AfriexRegionCode["WestAsia"] = "WEST_ASIA";
    AfriexRegionCode["SouthAsia"] = "SOUTH_ASIA";
    AfriexRegionCode["EastAsia"] = "EAST_ASIA";
    AfriexRegionCode["SouthEastAsia"] = "SOUTH_EAST_ASIA";
    // Oceania
    AfriexRegionCode["Oceania"] = "OCEANIA";
})(AfriexRegionCode || (AfriexRegionCode = {}));
//# sourceMappingURL=AfriexRegionCode.js.map